import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  SalesInvoiceData: null,
  DeliveryChallanData: null,
  ExpenseInvoiceData: null,
  QuotationData: null,
  NoteData: null,
};

const InvoiceSlice = createSlice({
  name: "Invoice",
  initialState,
  reducers: {
    setSalesInvoiceData(state, action) {
      state.SalesInvoiceData = action.payload;
    },
    setDeliveryChallanData(state, action) {
      state.DeliveryChallanData = action.payload;
    },
    setExpenseInvoiceData(state, action) {
      state.ExpenseInvoiceData = action.payload;
    },
    setQuotationData(state, action) {
      state.QuotationData = action.payload;
    },
    setNoteData(state, action) {
      state.QuotationData = action.payload;
    },
  },
});

export default InvoiceSlice.reducer;
export const {
  setSalesInvoiceData,
  setDeliveryChallanData,
  setExpenseInvoiceData,
  setQuotationData,
  setNoteData,
} = InvoiceSlice.actions;
